import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7228b8aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-1 px-2" }
const _hoisted_2 = { style: {"font-size":"16px"} }
const _hoisted_3 = {
  key: 0,
  class: "bi bi-text-indent-right"
}
const _hoisted_4 = {
  key: 1,
  class: "bi bi-chevron-bar-right"
}
const _hoisted_5 = ["onClick"]

import { navigationData } from "@/data/navigation";
import { useMiscStore } from '@/stores/misc';
import { useRoute } from "vue-router"
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const miscStore = useMiscStore();
const route = useRoute();

function getIsSidebar () {
  return miscStore.isSidebarDisplay;
}

function toggleIsSidebar () {
  return miscStore.isSidebarDisplay = !miscStore.isSidebarDisplay;
}
const isDesktop = useMediaQuery('(min-width: 992px)')

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    id: "Sidebar",
    isCollapse: !getIsSidebar()
  }, {
    default: _withCtx(() => [
      (!_unref(isDesktop))
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            class: "collapse-btn justify-content-end action-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_button, {
                  onClick: toggleIsSidebar,
                  round: "",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      (getIsSidebar())
                        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                        : (_openBlock(), _createElementBlock("i", _hoisted_4))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationData), (item, index) => {
        return (_openBlock(), _createBlock(_component_el_menu_item, {
          key: item.name,
          index: `${index}`,
          class: _normalizeClass([{'is-active': _unref(route).name == item.name}, {'action-item': item.action}])
        }, {
          default: _withCtx(() => [
            (item.route)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "nav-link d-block w-100 px-4",
                  "active-class": "active",
                  to: item.route
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (item.name == 'Logout')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "d-block w-100 mx-4",
                    onClick: item.action,
                    type: "danger",
                    round: "",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Logout")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (item.action)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      onClick: item.action,
                      class: _normalizeClass(['d-block w-100 px-4 pointer', {'nav-link': item.iconName != 'log-out'}])
                    }, _toDisplayString(item.name), 11, _hoisted_5))
                  : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["index", "class"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["isCollapse"]))
}
}

})